export function downloadBase64File(base64Data, fileName, mimeType) {
    const link = document.createElement('a');
    link.href = base64Data; // full data URL works directly
    link.download = generateFileNameFromBase64(base64Data, fileName);
    link.click();
  // console.log("jfjfjfhjhjghgfhgfhgfhgfhgfhf",base64Data)
  // const byteCharacters = atob(base64Data);
  // const byteNumbers = new Array(byteCharacters.length);

  // for (let i = 0; i < byteCharacters.length; i++) {
  //   byteNumbers[i] = byteCharacters.charCodeAt(i);
  // }

  // const byteArray = new Uint8Array(byteNumbers);
  // const blob = new Blob([byteArray], { type: mimeType });

  // const link = document.createElement("a");
  // link.href = URL.createObjectURL(blob);
  // link.download = fileName;
  // document.body.appendChild(link);
  // link.click();

  // document.body.removeChild(link);
  // URL.revokeObjectURL(link.href);
}

export function generateFileBase64(file) {

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      // This already includes: data:<type>;base64,...
      resolve(reader.result);
    };

    reader.onerror = error => reject(error);

    reader.readAsDataURL(file);
  });

}


function generateFileNameFromBase64(base64String, defaultName = "file") {
    if (!base64String.startsWith("data:")) {
        throw new Error("Invalid Base64 data URL");
    }

    // Extract mime type
    const mimeMatch = base64String.match(/^data:(.*?);base64,/);
    if (!mimeMatch) {
        throw new Error("MIME type not found in Base64 string");
    }

    const mimeType = mimeMatch[1];

    // Map MIME type to extension
    const mimeToExtension = {
        "application/pdf": "pdf",
        "image/png": "png",
        "image/jpeg": "jpg",
        "image/jpg": "jpg",
        "image/gif": "gif",
        "image/webp": "webp",
        "text/plain": "txt",
        "text/html": "html",
        "application/json": "json",
        "application/zip": "zip",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx"
    };

    const extension = mimeToExtension[mimeType] || mimeType.split("/")[1] || "bin";

    // Generate timestamp-based name
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");

    return `${defaultName}-${timestamp}.${extension}`;
}